import {defineType} from 'sanity'
import {VscLink} from 'react-icons/vsc'
import dotcomPage, {defaultDotComPreviewConfig} from '../fragments/dotcom.page'
import dotcomShip from '../fragments/dotcom.ship'
import dotcomDestination from '../fragments/dotcom.destination'
import dotcomSubDestination from '../fragments/dotcom.subDestination'
const dotcomPreviewConfig = defaultDotComPreviewConfig('dotcomPage')

export default defineType({
  name: 'inline-banner-item',
  title: 'Inline Banner Item',
  icon: VscLink,
  type: 'object',

  fields: [
    {
      name: 'type',
      type: 'string',
      title: 'Type',
      validation: (rule) => rule.required(),
      options: {
        list: [
          {title: 'silversea.com page', value: 'dotcom'},
          {title: 'Manual', value: 'manual'},
        ],
      },
    },
    {
      ...dotcomPage,
      to: [...dotcomPage.to, ...dotcomDestination.to, ...dotcomShip.to, ...dotcomSubDestination.to],
      weak: true,
      hidden: ({parent}) => parent?.type !== 'dotcom',
    },

    {
      name: 'image',
      type: 'image',
      title: 'Image',
      description:
        "if type is 'silversea.com page', use this to override the image from the dotcom page",
    },
    {
      name: 'title',
      type: 'string',
      title: 'Title',
      description:
        "if type is 'silversea.com page', use this to override the title from the dotcom page",
    },
    {
      name: 'content',
      type: 'text',
      title: 'Content',
      description:
        "if type is 'silversea.com page', use this to override the content from the dotcom page",
    },
    {
      name: 'ctaButtons',
      type: 'ctaButtons',
      hidden: ({parent}) => parent?.type !== 'manual',
    },
  ],
  preview: {
    select: {
      type: 'type',
      title: 'title',
      subtitle: 'content',
      media: 'image',
      ...defaultDotComPreviewConfig('dotcomPage').select,
    },

    prepare: ({title, subtitle, media, ...dotcomProps}) => {
      if (dotcomPreviewConfig.prepare) {
        const dotcomPreview = dotcomPreviewConfig.prepare(dotcomProps)
        return {
          title: dotcomPreview.title || title,
          subtitle: dotcomPreview.subtitle || subtitle,
          media: dotcomPreview.media || media,
        }
      }

      return {
        title: title,
        subtitle: subtitle,
        media,
      }
    },
  },
})
